module.exports = __webpack_public_path__ + "static/media/38-5.b5a204f3.mp3";